import { useState } from "react";
import ModalAbrirTurno from "./AbrirTurno";

export const useTurnoModal = () => {
  const [visible, setVisible] = useState(false);
  const [callback, setCallback] = useState(null);

  const abrirModal = (cb) => {
    setCallback(() => cb);
    setVisible(true);
  };

  const fecharModal = () => {
    setVisible(false);
  };

  const modal = (
    <ModalAbrirTurno
      open={visible}
      onClose={fecharModal}
      onTurnoAberto={(turno) => {
        if (callback) callback(turno);
        fecharModal();
      }}
    />
  );

  return {
    abrirModal,
    modal
  };
};
